import * as PIXI from 'pixi.js';
import { EVENTS } from '../../lib/constants';
import { isMobile, isTablet } from 'react-device-detect';
import { GameConfigs } from '../../lib/globals/GameConfigs';

let starAmount = 50;
let cameraZ = 0;
let cameraZComet = 0;
const fov = 20;
let baseSpeed = GameConfigs.settings.game_animation ? 0.025 : 0;
let speed = 0;
let speedComet = 0;
let starStretch = 2;
const starBaseSize = isMobile || isTablet ? 0.3 : 1;
let coefVal = GameConfigs.settings.game_animation ? 0.3 : 0;

let cometAmount = 30;
const cometBaseSize = 0.3;
let cometStretch = 0.1;

let game_animation = GameConfigs.settings.game_animation;
// Create the stars
const stars = [];
const comets = [];
const starContainer = new PIXI.Sprite();
let coefValComet = GameConfigs.settings.game_animation ? 0.1 : 0;

const handleSettings = (e) => {
	if (e.detail.data.game_animation === undefined) return;
	if (e.detail.data.game_animation) {
		coefVal = 0.3;
		coefValComet = 0.1;
		baseSpeed = 0.025;
		game_animation = true;
	} else {
		coefVal = 0;
		coefValComet = 0;
		baseSpeed = 0;
		game_animation = false;
	}
};

const handleBetPlace = (e) => {
	if (!game_animation) return;
	if (e.detail.placed) {
		coefVal = 1;
		coefValComet = 0.5;
	}
};

const handleReelFinish = (e) => {
	if (!game_animation) return;
	coefVal = 0.1;
	coefValComet = 0.05;
};

const handleBait = (e) => {
	if (!game_animation) return;
	if (e.detail.bait) {
		coefVal = 4;
		coefValComet = 0.5;
	}
};

const randomizeStar = (star, initial) => {
	star.z = initial
		? Math.random() * 2000
		: cameraZ + Math.random() * 1000 + 2000;
	// Calculate star positions with radial random coordinate so no star hits the camera.
	const deg = Math.random() * Math.PI * 2;
	const distance = Math.random() * 50 + 10;
	star.x = Math.cos(deg) * distance;
	star.y = Math.sin(deg) * distance;
};

const randomizeComet = (comet, initial) => {
	comet.z = initial
		? Math.random() * 2000
		: cameraZComet + Math.random() * 1000 + 2000;
	// Calculate star positions with radial random coordinate so no star hits the camera.
	const deg = Math.random() * Math.PI * 2;
	const distance = Math.random() * 50 + 10;
	comet.x = Math.cos(deg) * distance;
	comet.y = Math.sin(deg) * distance;
};
// let timeout;
// let interval;

export const createStars = (stage, ticker, app, configs) => {
	baseSpeed = configs ? 0.025 : 0;
	coefVal = configs ? 0.3 : 0;
	coefValComet = configs ? 0.1 : 0;
	game_animation = configs;

	// Get the texture for rope.
	const starTexture = PIXI.Texture.from('star');
	const cometTexture = PIXI.Texture.from('cometPng');
	window.addEventListener(
		EVENTS.BET_PLACED,
		(e) => {
			handleBetPlace(e);
		},
		false
	);

	window.addEventListener(
		EVENTS.BAIT,
		(e) => {
			handleBait(e);
		},
		false
	);
	window.addEventListener(EVENTS.SETTINGS_UPDATE, (e) => {
		handleSettings(e);
	});
	window.addEventListener(
		EVENTS.REEL_FINISHED,
		(e) => {
			handleReelFinish(e);
		},
		false
	);

	for (let i = 0; i < cometAmount; i++) {
		const comet = {
			sprite: new PIXI.Sprite(cometTexture),
			z: 0,
			x: 0,
			y: 0
		};
		comet.sprite.alpha = 0.5;
		comet.sprite.anchor.x = 0.5;
		comet.sprite.anchor.y = 0.5;
		randomizeComet(comet, true);
		starContainer.addChild(comet.sprite);

		comets.push(comet);
	}

	for (let i = 0; i < starAmount; i++) {
		const star = {
			sprite: new PIXI.Sprite(starTexture),
			z: 0,
			x: 0,
			y: 0
		};
		star.sprite.alpha = 0.5;
		star.sprite.anchor.x = 0.5;
		star.sprite.anchor.y = 0.7;
		randomizeStar(star, true);
		starContainer.addChild(star.sprite);

		stars.push(star);
	}
	starContainer.name = 'starContainer';
	stage.addChild(starContainer);
	ticker.add((delta) => {
		// Change speed depend on coeficient
		speed = coefVal;
		speedComet = coefValComet;
		cameraZ += delta * 10 * (speed + baseSpeed);
		cameraZComet += delta * 10 * (speedComet + baseSpeed);
		for (let i = 0; i < cometAmount; i++) {
			const comet = comets[i];
			if (comet.z < cameraZComet) randomizeComet(comet, false);

			const z = comet.z - cameraZComet;

			comet.sprite.x =
				comet.x * (fov / z) * app.renderer.screen.width +
				app.renderer.screen.width / 2;
			comet.sprite.y =
				comet.y * (fov / z) * app.renderer.screen.width +
				app.renderer.screen.height / 2;
			const dxCenter = comet.sprite.x - app.renderer.screen.width / 2;
			const dyCenter = comet.sprite.y - app.renderer.screen.height / 2;

			const distanceCenter = Math.sqrt(
				dxCenter * dxCenter + dyCenter * dyCenter
			);
			const distanceScale = Math.max(0, (2000 - z) / 2000);
			comet.sprite.scale.x = distanceScale * cometBaseSize;
			// Star is looking towards center so that y axis is towards center.
			// Scale the star depending on how fast we are moving, what the stretchfactor is and depending on how far away it is from the center.
			comet.sprite.scale.y =
				distanceScale * cometBaseSize +
				(distanceScale * speedComet * cometStretch * distanceCenter) /
					app.renderer.screen.width;
			comet.sprite.rotation = Math.atan2(dyCenter, dxCenter) + Math.PI / 2;
		}

		for (let i = 0; i < starAmount; i++) {
			const star = stars[i];
			if (star.z < cameraZ) randomizeStar(star, false);

			const z = star.z - cameraZ;

			star.sprite.x =
				star.x * (fov / z) * app.renderer.screen.width +
				app.renderer.screen.width / 2;
			star.sprite.y =
				star.y * (fov / z) * app.renderer.screen.width +
				app.renderer.screen.height / 2;
			const dxCenter = star.sprite.x - app.renderer.screen.width / 2;
			const dyCenter = star.sprite.y - app.renderer.screen.height / 2;

			const distanceCenter = Math.sqrt(
				dxCenter * dxCenter + dyCenter * dyCenter
			);
			const distanceScale = Math.max(0, (2000 - z) / 2000);
			star.sprite.scale.x = distanceScale * starBaseSize;
			// Star is looking towards center so that y axis is towards center.
			// Scale the star depending on how fast we are moving, what the stretchfactor is and depending on how far away it is from the center.
			star.sprite.scale.y =
				distanceScale * starBaseSize +
				(distanceScale * speed * starStretch * distanceCenter) /
					app.renderer.screen.width;
			star.sprite.rotation = Math.atan2(dyCenter, dxCenter) + Math.PI / 2;
		}
	});
};
